import { render, staticRenderFns } from "./ModalPriceSetting.vue?vue&type=template&id=7b2eb0bc&scoped=true&"
import script from "./ModalPriceSetting.vue?vue&type=script&lang=js&"
export * from "./ModalPriceSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2eb0bc",
  null
  
)

export default component.exports